var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.loading)?_c('div',[_c('v-skeleton-loader',{attrs:{"type":"card"}})],1):_c('div',[(_vm.content)?_c('div',[_c('object',{staticStyle:{"width":"100%","height":"900px"},attrs:{"id":"pdf_viewer","data":_vm.content,"type":"application/pdf"}})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c29fdc0c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/meetingpdfviewer/MeetingPdfViewer.vue
// module id = 1756
// module chunks = 0